module.exports = __webpack_public_path__ + "static/media/costco_round.baf92abf.svg";